import {
  BooleanField,
  Datagrid,
  DateField,
  FunctionField,
  List,
  NumberField,
  TextField,
  TextInput,
} from "react-admin";
import QuickFilter from "../Componentes/BooleanChipFilter";
import { NotificationReadField } from "./NotificationReadField";

const filters = [
  <QuickFilter source="nao_lidas" label="Não Lidas" defaultValue={true} />,
  <TextInput source="titulo" label="Título" resettable />,
];

export const NotificationsList = () => (
  <List
    sort={{ field: "id", order: "DESC" }}
    perPage={25}
    filters={filters}
    // Módulo 38 é o SCM
    filterDefaultValues={{ nao_lidas: true, modulo: "SCM" }}
    exporter={false}
  >
    <Datagrid bulkActionButtons={false} rowClick={false}>
      <NumberField source="id" options={{ useGrouping: false }} />
      <FunctionField
        label="Título Notificação"
        render={(record) => <NotificationReadField record={record} />}
      />
      <TextField source="sigla_modulo" label="Módulo" />
      <TextField source="usu_criador" />
      <DateField source="data_hora" showTime />
      <BooleanField source="nao_lida" />
    </Datagrid>
  </List>
);
